import { useCallback } from 'react';
import { useAsyncData } from '@/hooks';
import { eventsService } from '@/features/events/services/eventsService';
import type { Event, AllEventsResponse } from '@/features/events/types/types';

export function useEvents() {
  const fetchEvents = useCallback(async (): Promise<Event[]> => {
    const response: AllEventsResponse = await eventsService.getAllEvents();
    return response.data.map(item => item.event);
  }, []);

  const { data: events, loading, error, refetch } = useAsyncData(fetchEvents);

  return {
    events: events || [],
    loading,
    error,
    fetchEvents: refetch
  };
}
